import ResendEmailConfirmationForm from './ResendEmailConfirmationForm';

export default ResendEmailConfirmationForm;
